module.exports = __webpack_public_path__ + "img/dhl-c.c275d953.jpg";